var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgFeature2 = function SvgFeature2(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 702,
    height: 493.386,
    viewBox: "0 0 702 493.386",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Feature2",
    transform: "translate(-32.406 -78.659)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "undraw_Ethereum_re_0m68",
    transform: "translate(-210.387 109.262)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_471",
    "data-name": "Path 471",
    d: "M594.285,26,461.414,245.063,594,323.526Z",
    transform: "translate(0)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_472",
    "data-name": "Path 472",
    d: "M461.549,134.142,593.686,73.916l-.163,138.333Z",
    transform: "translate(0.314 111.37)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_473",
    "data-name": "Path 473",
    d: "M501.211,26,634.086,245.063,501.5,323.526Z",
    transform: "translate(92.499)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_474",
    "data-name": "Path 474",
    d: "M633.435,134.142,501.3,73.916l.159,138.333Z",
    transform: "translate(92.701 111.37)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_475",
    "data-name": "Path 475",
    d: "M461.549,99.595,593.523,285.439V177.7Z",
    transform: "translate(0.314 171.055)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_476",
    "data-name": "Path 476",
    d: "M633.226,99.595,501.249,285.439V177.7Z",
    transform: "translate(92.588 171.055)",
    fill: "#3f3d56"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_139",
    "data-name": "Ellipse 139",
    cx: 32,
    cy: 32,
    r: 32,
    transform: "translate(439.495 78.659)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_431",
    "data-name": "Path 431",
    d: "M745.481,247.412a3.437,3.437,0,0,0-1.575-1.747,5.394,5.394,0,0,0-1.424-.58,3.482,3.482,0,0,0,.914-.638,3.282,3.282,0,0,0,.875-1.352,4.621,4.621,0,0,0,.2-1.637,4.992,4.992,0,0,0-.74-2.6,4.633,4.633,0,0,0-2.108-1.567,7.682,7.682,0,0,0-2.551-.517v-3.708l-2.242,1.451v2.264h-1.794V234.4l-2.3-1.335v3.714H727.85l1.57,2.786a2.447,2.447,0,0,1,.981.133.753.753,0,0,1,.364.348,2.885,2.885,0,0,1,.107,1.016v10.052a2.887,2.887,0,0,1-.106,1.01c-.073.151-.112.284-.286.366s-.179.075-.661.075h-.006l-1.962,2.786h4.877v3.714h2.3v-3.714h1.794v3.714h2.242v-3.738a10.629,10.629,0,0,0,3.33-.6A5.477,5.477,0,0,0,744.9,252.9a5.8,5.8,0,0,0,.886-2.971,6.754,6.754,0,0,0-.3-2.519Zm-10.455-7.5h0v-.077h1.567c.882,0,3.82-.3,3.869,2.18s-3.869,2.383-3.869,2.383h-1.568v-.192h0Zm0,7.08h1.794c.364,0,1.618.057,2.074.079a1.929,1.929,0,0,1,.547.1c.064.023.126.048.192.077a2.753,2.753,0,0,1,.773.405,1.639,1.639,0,0,1,.4.389,2.607,2.607,0,0,1,.448,1.433,2.086,2.086,0,0,1-.28,1.143,2.649,2.649,0,0,1-1.21,1.033,7.555,7.555,0,0,1-2.945.563h-1.794Z",
    transform: "translate(-263.692 -135.407)",
    fill: "#c1e9e5",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_432",
    "data-name": "Path 432",
    d: "M986.741,668.376c-27.28,41.835-19.8,95.043-19.8,95.043s51.7-14.619,78.983-56.454,19.805-95.043,19.805-95.043S1014.02,626.542,986.741,668.376Z",
    transform: "translate(-332.255 -192.648)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_433",
    "data-name": "Path 433",
    d: "M966.791,762.933s-.664-.106-1.886-.353c-.975-.2-2.317-.48-3.956-.869-14.653-3.455-53.608-15.133-79.077-45.837-31.877-38.447-30.534-92.161-30.534-92.161s48.74,7.92,80.857,42.445q2.088,2.225,4.062,4.613c27.737,33.452,30.322,78.462,30.527,89.589C966.812,762.028,966.791,762.933,966.791,762.933Z",
    transform: "translate(-332.255 -192.648)",
    fill: "#c1e9e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_434",
    "data-name": "Path 434",
    d: "M947.131,668.376c27.28,41.835,19.8,95.043,19.8,95.043s-51.7-14.619-78.983-56.454-19.8-95.043-19.8-95.043S919.851,626.542,947.131,668.376Z",
    transform: "translate(-332.255 -192.648)",
    fill: "none",
    stroke: "#3f3d56",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_435",
    "data-name": "Path 435",
    d: "M966.783,760.361c-.721.869-1.356,1.611-1.879,2.218-1.159,1.321-1.816,2.013-1.816,2.013s-.8-1-2.141-2.882c-7.369-10.272-31.071-46.8-29.241-88.989q.148-3.317.487-6.563,2.088,2.225,4.062,4.613C963.993,704.224,966.579,749.234,966.783,760.361Z",
    transform: "translate(-332.255 -192.648)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_436",
    "data-name": "Path 436",
    d: "M1007.23,675.773c-2.156,49.9-39.2,88.82-39.2,88.82s-33.543-41.974-31.387-91.871,39.2-88.82,39.2-88.82S1009.39,625.876,1007.23,675.773Z",
    transform: "translate(-332.255 -192.648)",
    fill: "#c1e9e5"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_13",
    "data-name": "Line 13",
    y1: 177.243,
    x2: 8.143,
    transform: "translate(635.782 393.289)",
    fill: "none",
    stroke: "#3f3d56",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_14",
    "data-name": "Line 14",
    x2: 647.105,
    transform: "translate(57.472 570.727)",
    fill: "none",
    stroke: "#3f3d56",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_142",
    "data-name": "Ellipse 142",
    cx: 42.73,
    cy: 42.73,
    r: 42.73,
    transform: "translate(145.672 287.853)",
    fill: "#c1e9e5"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_143",
    "data-name": "Ellipse 143",
    cx: 42.73,
    cy: 42.73,
    r: 42.73,
    transform: "translate(121.796 383.757)",
    fill: "#c1e9e5"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_144",
    "data-name": "Ellipse 144",
    cx: 42.73,
    cy: 42.73,
    r: 42.73,
    transform: "translate(32.406 449.989)",
    fill: "#c1e9e5"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_15",
    "data-name": "Line 15",
    y1: 77.51,
    transform: "translate(75.098 492.483)",
    fill: "#3f3d56",
    stroke: "#3f3d56",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_145",
    "data-name": "Ellipse 145",
    cx: 10.961,
    cy: 10.961,
    r: 10.961,
    transform: "translate(64.137 481.522)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_437",
    "data-name": "Path 437",
    d: "M208.437,732.9s-1.566-33.678-33.666-29.764",
    transform: "translate(-133.339 -192.648)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_16",
    "data-name": "Line 16",
    y1: 258.538,
    transform: "translate(184.008 311.999)",
    fill: "#3f3d56",
    stroke: "#3f3d56",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_146",
    "data-name": "Ellipse 146",
    cx: 10.961,
    cy: 10.961,
    r: 10.961,
    transform: "translate(174.107 320.614)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_147",
    "data-name": "Ellipse 147",
    cx: 10.961,
    cy: 10.961,
    r: 10.961,
    transform: "translate(147.644 487.969)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_438",
    "data-name": "Path 438",
    d: "M370.522,560.515s-1.566-33.678-33.666-29.764",
    transform: "translate(-181.22 -175.079)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_439",
    "data-name": "Path 439",
    d: "M370.522,655.989s-1.566-33.678-33.666-29.764",
    transform: "translate(-181.22 -179.776)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_440",
    "data-name": "Path 440",
    d: "M370.522,760.173s7.046-65.462-33.666-68.594",
    transform: "translate(-181.245 -192.648)",
    fill: "none",
    stroke: "#3f3d56",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_148",
    "data-name": "Ellipse 148",
    cx: 10.961,
    cy: 10.961,
    r: 10.961,
    transform: "translate(200.574 487.969)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_441",
    "data-name": "Path 441",
    d: "M370.527,760.173s-7.046-65.462,33.666-68.594",
    transform: "translate(-188.443 -192.648)",
    fill: "none",
    stroke: "#3f3d56",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_149",
    "data-name": "Ellipse 149",
    cx: 10.961,
    cy: 10.961,
    r: 10.961,
    transform: "translate(201.099 400.686)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_442",
    "data-name": "Path 442",
    d: "M371.194,653.862s-7.046-61.97,33.666-65.1",
    transform: "translate(-188.587 -179.155)",
    fill: "none",
    stroke: "#3f3d56",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_17",
    "data-name": "Line 17",
    y1: 157.813,
    transform: "translate(164.565 412.359)",
    fill: "#3f3d56",
    stroke: "#3f3d56",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_150",
    "data-name": "Ellipse 150",
    cx: 10.961,
    cy: 10.961,
    r: 10.961,
    transform: "translate(153.604 416.13)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_443",
    "data-name": "Path 443",
    d: "M297.9,649.647s-1.566-33.678-33.666-29.764",
    transform: "translate(-133.339 -179.464)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_444",
    "data-name": "Path 444",
    d: "M297.9,759.808s7.046-64.764-33.666-67.9",
    transform: "translate(-133.339 -192.648)",
    fill: "none",
    stroke: "#3f3d56",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_151",
    "data-name": "Ellipse 151",
    cx: 10.961,
    cy: 10.961,
    r: 10.961,
    transform: "translate(119.938 488.303)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_152",
    "data-name": "Ellipse 152",
    cx: 18,
    cy: 18,
    r: 18,
    transform: "translate(549.567 313.891)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_445",
    "data-name": "Path 445",
    d: "M709.351,636.366c-22.96,10.44-52.53,9.7-52.53,9.7h-32v-6.11c13.04-3.64,31.07-5.89,51-5.89A233.662,233.662,0,0,1,709.351,636.366Z",
    transform: "translate(-250.129 -179.545)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_446",
    "data-name": "Path 446",
    d: "M747.821,654.066c0,11.05-32.24,20-72,20s-72-8.95-72-20c0-5.51,8.02-10.5,21-14.11v6.11h32s29.57.74,52.53-9.7C732.221,639.706,747.821,646.376,747.821,654.066Z",
    transform: "translate(-253.626 -192.648)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_135",
    "data-name": "Rectangle 135",
    width: 30.635,
    height: 30.69,
    transform: "translate(404.753 354.478)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_447",
    "data-name": "Path 447",
    d: "M665.775,551.238s2.536,8.875-1.9,9.509a17.324,17.324,0,0,0-7.607,3.17l8.241,10.777h15.214l9.509-9.509s-12.679-9.509-10.143-15.214S665.775,551.238,665.775,551.238Z",
    transform: "translate(-250.334 -175.815)",
    fill: "#ffb9b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_448",
    "data-name": "Path 448",
    d: "M665.775,551.238s2.536,8.875-1.9,9.509a17.324,17.324,0,0,0-7.607,3.17l8.241,10.777h15.214l9.509-9.509s-12.679-9.509-10.143-15.214S665.775,551.238,665.775,551.238Z",
    transform: "translate(-250.334 -175.815)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_449",
    "data-name": "Path 449",
    d: "M536.239,526.136l14.581,5.071,10.142.634-.634-8.875-20.919-6.187Z",
    transform: "translate(-118.805 -57.242)",
    fill: "#ffb9b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_450",
    "data-name": "Path 450",
    d: "M688.279,659.641s0,8.875,1.268,8.875,18.384-1.9,23.456,0,12.679-5.071,8.875-8.875S711.87,650.132,708,651.4s-19.719,4.438-19.719,4.438Z",
    transform: "translate(-257.491 -192.648)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_451",
    "data-name": "Path 451",
    d: "M641.685,651.4s-7.607,15.214-2.536,16.482,10.777-.634,11.411-1.268,9.509-3.17,10.777-1.9,1.268-5.071,1.268-5.071Z",
    transform: "translate(-245.298 -192.648)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_452",
    "data-name": "Path 452",
    d: "M648.025,630.48s-12.045,16.482-3.17,20.92,51.349,4.438,54.518,0,4.438-18.384,0-19.652S648.025,630.48,648.025,630.48Z",
    transform: "translate(-250.719 -179.799)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_453",
    "data-name": "Path 453",
    d: "M648.025,630.48s-12.045,16.482-3.17,20.92,51.349,4.438,54.518,0,4.438-18.384,0-19.652S648.025,630.48,648.025,630.48Z",
    transform: "translate(-250.719 -179.799)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_153",
    "data-name": "Ellipse 153",
    cx: 14.58,
    cy: 14.58,
    r: 14.58,
    transform: "translate(406.417 351.664)",
    fill: "#ffb9b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_454",
    "data-name": "Path 454",
    d: "M648.025,563.917l12.679-2.536s3.17,10.143,13.313,8.241,12.679-8.241,12.679-8.241,7.607,3.17,8.241,3.17,8.875,3.17,8.875,5.071-9.509,20.92-9.509,20.92l1.268,34.232-46.911-1.268,3.17-33.6Z",
    transform: "translate(-251.505 -177.79)",
    fill: "#c1e9e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_455",
    "data-name": "Path 455",
    d: "M641.051,580.4s-3.8,33.6-1.268,36.134,12.679,9.509,12.679,9.509v-7.607l-5.071-9.509,5.071-22.188Z",
    transform: "translate(-244.217 -178.09)",
    fill: "#ffb9b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_456",
    "data-name": "Path 456",
    d: "M706.663,579.448s-2.219,34.549-2.219,35.817-5.705,5.705-7.607,5.705-3.17-3.17-3.17-3.17l4.438-5.071-3.17-25.991Z",
    transform: "translate(-255.756 -177.899)",
    fill: "#ffb9b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_457",
    "data-name": "Path 457",
    d: "M700.641,627.944s28.527-15.848,29.161,0-14.58,22.188-14.58,22.188-39.3,11.786-40.889,7.478-4.755-11.281-2.219-11.915,5.705-1.9,6.973-.634,17.116-9.509,17.116-9.509Z",
    transform: "translate(-257.039 -179.791)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_458",
    "data-name": "Path 458",
    d: "M713.954,626.042s-5.705,2.536-7.607,4.438-10.143,5.071-10.143,5.071",
    transform: "translate(-256.923 -179.057)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_459",
    "data-name": "Path 459",
    d: "M651.828,565.185l-3.8-1.268s-13.946,14.58-9.509,18.384,6.973,5.071,8.241,6.339,7.607,1.9,7.607,1.9Z",
    transform: "translate(-244.326 -176.6)",
    fill: "#c1e9e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_460",
    "data-name": "Path 460",
    d: "M698.1,568.354l5.705,1.268s4.438,9.509,5.705,10.777-1.9.634-3.8,3.17-3.8,6.973-7.607,6.973-8.875-6.339-8.875-6.339Z",
    transform: "translate(-255.81 -176.657)",
    fill: "#c1e9e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_461",
    "data-name": "Path 461",
    d: "M649.293,633.65s-24.089-17.116-32.331-4.437,35.5,29.795,41.839,32.331,12.045,5.071,12.045,5.071,5.705-13.946,5.705-16.482-4.437-2.536-5.705-2.536-6.973-1.268-8.241-3.17S649.293,633.65,649.293,633.65Z",
    transform: "translate(-244.989 -180.119)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_462",
    "data-name": "Path 462",
    d: "M635.98,629.212s6.339,5.071,12.045,6.339,7.607,4.438,7.607,4.438",
    transform: "translate(-244.322 -179.26)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_463",
    "data-name": "Path 463",
    d: "M644.92,605.376l.506,26.841a3.36,3.36,0,0,0,3.4,3.3l49.949-.561a3.36,3.36,0,0,0,3.317-3.166l1.516-26.28a3.36,3.36,0,0,0-3.354-3.554H648.279a3.36,3.36,0,0,0-3.359,3.423Z",
    transform: "translate(-251.2 -178.72)",
    fill: "#575a89"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_464",
    "data-name": "Path 464",
    d: "M639.142,564.077c1.36-3,3.189-5.819,4.06-9,1.044-3.81.638-7.841.513-11.789a37.016,37.016,0,0,1,.884-10.4,17.885,17.885,0,0,1,5.142-8.953c6.643-5.931,18.8-6.356,26.914-3.888,3.2.973,6.6,2.827,7.4,6.074.12.49.173,1,.307,1.482.664,2.418,3.138,3.948,4.03,6.291,1.154,3.031-.626,6.327-.858,9.561-.272,3.777,1.585,7.344,3.415,10.659,1.088,1.971,2.219,4.07,2.111,6.318a7.982,7.982,0,0,1-1.092,3.483,13.281,13.281,0,0,1-11.156,6.395,7,7,0,0,1-4.179-.986c-1.98-1.363-2.56-4.108-2.147-6.476s1.614-4.51,2.556-6.721c.289-.679.55-1.369.79-2.066a14.185,14.185,0,1,0-9.357,1.587,19.216,19.216,0,0,1-.93,10.685,40.344,40.344,0,0,1-4.487,7.823,10.8,10.8,0,0,1-2.858,3.2,10.143,10.143,0,0,1-2.435,1.04c-3.581,1.152-7.351,2.078-11.077,1.56s-7.415-2.765-8.684-6.306C636.888,570.546,637.781,567.079,639.142,564.077Z",
    transform: "translate(-249.14 -175.675)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_154",
    "data-name": "Ellipse 154",
    cx: 15.474,
    cy: 8.768,
    rx: 15.474,
    ry: 8.768,
    transform: "translate(404.936 349.843)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_465",
    "data-name": "Path 465",
    d: "M906.55,506.112a2.671,2.671,0,0,0-1.224-1.357,4.191,4.191,0,0,0-1.106-.451,2.706,2.706,0,0,0,.71-.5,2.55,2.55,0,0,0,.68-1.051,3.6,3.6,0,0,0,.152-1.272,3.879,3.879,0,0,0-.575-2.02,3.6,3.6,0,0,0-1.638-1.218,5.968,5.968,0,0,0-1.982-.4v-2.882l-1.742,1.127v1.759H898.43V496l-1.786-1.037v2.886H892.85l1.22,2.165a1.9,1.9,0,0,1,.762.1.585.585,0,0,1,.283.271,2.24,2.24,0,0,1,.083.789v7.811a2.245,2.245,0,0,1-.083.785c-.057.117-.087.221-.222.284s-.139.059-.514.059h0l-1.525,2.165h3.79v2.886h1.786v-2.886h1.394v2.886h1.742v-2.9a8.26,8.26,0,0,0,2.588-.465,4.255,4.255,0,0,0,1.947-1.421,4.508,4.508,0,0,0,.688-2.309,5.249,5.249,0,0,0-.236-1.957Zm-8.124-5.827h0v-.06h1.218c.685,0,2.969-.236,3.007,1.694s-3.007,1.852-3.007,1.852h-1.218v-.149h0Zm0,5.5h1.394c.283,0,1.257.045,1.612.061a1.5,1.5,0,0,1,.425.078c.05.018.1.037.149.06a2.139,2.139,0,0,1,.6.315,1.273,1.273,0,0,1,.311.3,2.028,2.028,0,0,1,.348,1.114,1.62,1.62,0,0,1-.217.888,2.058,2.058,0,0,1-.94.8,5.869,5.869,0,0,1-2.288.437h-1.394Z",
    transform: "translate(-332.255 -172.954)",
    fill: "#c1e9e5",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_155",
    "data-name": "Ellipse 155",
    cx: 18,
    cy: 18,
    r: 18,
    transform: "translate(46.482 373.803)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_466",
    "data-name": "Path 466",
    d: "M204.55,569.112a2.671,2.671,0,0,0-1.224-1.357,4.192,4.192,0,0,0-1.106-.451,2.706,2.706,0,0,0,.71-.5,2.55,2.55,0,0,0,.68-1.051,3.592,3.592,0,0,0,.152-1.272,3.879,3.879,0,0,0-.575-2.02,3.6,3.6,0,0,0-1.638-1.218,5.969,5.969,0,0,0-1.982-.4v-2.882l-1.742,1.127v1.759H196.43V559l-1.786-1.037v2.886H190.85l1.22,2.165a1.9,1.9,0,0,1,.762.1.585.585,0,0,1,.283.271,2.241,2.241,0,0,1,.083.789v7.811a2.244,2.244,0,0,1-.083.785c-.057.117-.087.221-.222.284s-.139.059-.514.059h0l-1.525,2.165h3.79v2.886h1.786v-2.886h1.394v2.886h1.742v-2.9a8.256,8.256,0,0,0,2.588-.464,4.256,4.256,0,0,0,1.947-1.421,4.508,4.508,0,0,0,.688-2.309A5.248,5.248,0,0,0,204.55,569.112Zm-8.124-5.827h0v-.06h1.218c.685,0,2.969-.236,3.007,1.694s-3.007,1.852-3.007,1.852h-1.218v-.149h0Zm0,5.5h1.394c.283,0,1.257.045,1.612.061a1.5,1.5,0,0,1,.425.078c.05.018.1.037.149.06a2.137,2.137,0,0,1,.6.315,1.273,1.273,0,0,1,.311.3,2.025,2.025,0,0,1,.348,1.114,1.62,1.62,0,0,1-.217.888,2.058,2.058,0,0,1-.94.8,5.868,5.868,0,0,1-2.288.438h-1.394Z",
    transform: "translate(-133.339 -176.07)",
    fill: "#c1e9e5",
    opacity: 0.3
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFeature2, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Feature2.88d9ec9e.svg";
export { ForwardRef as ReactComponent };